import { AppConfigType } from './app-config.type';

export const AppConfig: AppConfigType = {
  isDev: process.env.REACT_APP_IS_DEV === 'true',
};
